import { axios as cmAxios } from '../cm/common';
import { CM_BASE_URL } from '../../pages/constants/cmConstants';

// FIN-11360 — FRAML customer-level queue. Real BE: GET /cm/framl/queue
// (FramlQueueController → customer_framl_history). Response envelope is
// { customers, stats, pagination }; the reducer wants the stat counts flat,
// so map stats → top-level here.
export const getFramlCustomers = (params) =>
  cmAxios.get(`${CM_BASE_URL}/framl/queue`, { params }).then((res) => {
    if (res.status !== 200) throw new Error('Failed to load FRAML customers');
    const d = res.data || {};
    const stats = d.stats || {};
    return {
      customers: d.customers || [],
      totalCustomers: stats.totalCustomers || 0,
      totalAlerts: stats.totalAlerts || 0,
      fraudCount: stats.fraudCount || 0,
      amlCount: stats.amlCount || 0,
      crossDomainCount: stats.crossDomainCount || 0,
      lastComputedAt: stats.lastComputedAt ?? null,
      pagination: d.pagination || { page: 0, size: 10, total: 0 }
    };
  });

// Underlying alerts for one customer (row-expand). Real BE (FIN-12887):
// GET /cm/framl/customer-alerts/:key/alerts?page&size → FramlCustomerAlertsController →
// customer_framl_history_alert_contribution (latest live snapshot) ⋈ live alert_meta_data.
// Server-paged envelope { items, total, page, size } (size clamped to 100 BE-side).
// Distinct mount path from /framl/customers (FramlCustomerController, FIN-11398/77) —
// mounting both there collided and shadowed FramlCustomerController's routes with 405s.
export const getFramlCustomerAlerts = (customerKey, page = 0, size = 20) =>
  cmAxios
    .get(
      `${CM_BASE_URL}/framl/customer-alerts/${encodeURIComponent(
        customerKey
      )}/alerts`,
      { params: { page, size } }
    )
    .then((res) => {
      if (res.status !== 200)
        throw new Error('Failed to load FRAML customer alerts');
      const d = res.data;
      // Tolerate the pre-FIN-12887 flat-array shape (older BE deployments).
      return Array.isArray(d)
        ? { items: d, total: d.length, page: 0, size: d.length || size }
        : d || { items: [], total: 0, page: 0, size };
    });

// FIN-11360 Merge-to-Case: a customer's OPEN cases (latest-first) for the merge picker.
// Real BE: GET /cm/framl/customer-alerts/:key/open-cases → [{ caseId, caseName, status,
// department, ageDays }]. Head of the list = the customer's latest open case.
export const getOpenCasesForCustomer = (customerKey) =>
  cmAxios
    .get(
      `${CM_BASE_URL}/framl/customer-alerts/${encodeURIComponent(
        customerKey
      )}/open-cases`
    )
    .then((res) => {
      if (res.status !== 200) throw new Error('Failed to load open cases');
      return res.data || [];
    });

// FIN-11360 FE-5: export all filtered rows as a flat array (no pagination).
// Params: { source, riskBand, status, search, sortField, sortDir } — no page/size.
export const exportFramlQueue = (params) =>
  cmAxios.get(`${CM_BASE_URL}/framl/queue/export`, { params }).then((res) => {
    if (res.status !== 200) throw new Error('Failed to export FRAML queue');
    return res.data;
  });
